import { config } from "../Environment";

export interface ExtractItemsRequest {
  text: string;
  extractTypes: ("insight" | "action")[];
  language?: string;
  /** The prompt/question the text answers (e.g. a daily-reflection question) —
   *  keeps the AI from inventing action items out of visionary statements. */
  context?: string;
}

export interface ExtractedInsight {
  content: string;
  confidence: number;
  suggestedCategory?: string;
  suggestedTags?: string[];
}

export interface ExtractedAction {
  content: string;
  confidence: number;
  suggestedCategory?: string;
  suggestedPriority?: "high" | "medium" | "low";
  suggestedDueDate?: number; // Unix timestamp
  dueDateLabel?: string; // "Next Monday", "This week"
}

export interface ExtractItemsResponse {
  status: "SUCCESS" | "ERROR";
  insights?: ExtractedInsight[];
  actionItems?: ExtractedAction[];
  fault?: string;
}

/**
 * Unified extract items - extract both insights and action items from text using AI
 * POST /api/ai/extract-items
 */
export const extractItems = async (
  retryFetch: Function,
  request: ExtractItemsRequest
): Promise<ExtractItemsResponse> => {
  const response = await retryFetch(
    `${config.API_BASE}/api/ai/extract-items`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      credentials: "include",
      body: JSON.stringify(request),
    }
  );

  if (!response.ok) {
    const error = await response.json().catch(() => ({}));
    throw new Error(error.fault || error.message || "Failed to extract items");
  }

  return await response.json();
};
